var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socials"},[(_vm.emailAddress)?_c('a',{attrs:{"href":_vm.emailAddress}},[_vm._v("email")]):_vm._e(),(_vm.instagramLink)?_c('a',{attrs:{"href":_vm.instagramLink,"target":"_blank"}},[_vm._v("instagram")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }